import { useStaticQuery, graphql } from 'gatsby'

export const queryLocations = () => {
  const query = useStaticQuery(
    graphql`
      {
        sanityLocation {
          id
          internal {
            type
            content
            contentDigest
            owner
          }
        }
      }
    `
  )
  return JSON.parse(query.sanityLocation.internal.content)
}
